<template>
  <div >
    <el-drawer @reload="$reloadHandle" title="一键生成奖惩费用单" size="40%" :before-close="handleClose" :visible.sync="drawer"
               direction="rtl" append-to-body  custom-class="demo-drawer" ref="drawer" class="details2">

      <div class="demo-drawer__content">



        <template>
          <div>
            <div class="detail-wrap">
              <el-form ref="editForm" :model="formData">
                <el-form-item label="奖惩费用" label-width="100px">
                  <el-select v-model="formData.punishType" style="width:10vw!important;margin-top: 10px;"  clearable>
                    <el-option :value="1" label="星级奖励"></el-option>
                    <el-option :value="2" label="区域奖励"></el-option>
                    <el-option :value="3" label="翻倍奖励"></el-option>
                    <el-option :value="4" label="好评奖励"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="结算费用类型" label-width="100px">
                  <el-select v-model="formData.settleFeeType" style="width:10vw!important;margin-top: 10px;"  clearable>
                    <el-option :value="1" label="安装"></el-option>
                    <el-option :value="2" label="维修"></el-option>
                    <el-option :value="9" label="其他"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="工单开始时间" label-width="100px" >
                  <el-date-picker v-model="formData.beginDate" type="date" value-format="yyyy-MM-dd"
                                  placeholder="选择日期" style="margin-top:10px" >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="工单结束时间" label-width="100px" >
                  <el-date-picker v-model="formData.endDate" type="date" value-format="yyyy-MM-dd"
                                  placeholder="选择日期" style="margin-top:10px">
                  </el-date-picker>
                </el-form-item>

              </el-form>
            </div>
          </div>
        </template>
        <div class="demo-drawer__footer" style="position: absolute;
    bottom: 5px;
    right: 5px;">
          <el-button @click="cancelForm">取 消</el-button>
          <el-button type="primary" @click="doCommit">
            确 定
          </el-button>
        </div>
      </div>
    </el-drawer>

    <!-- 关闭弹窗 -->

  </div>
</template>
<script>
import request from "@/router/axios";
import api from "@/api/projectApi";
import store from "@/store";
export default {
  inject: ['reload'],
  name: 'edit',
  props: ['multi','param' ],
  components: {

  },
  created(){

  },
  data() {
    return {
      companyShortName: null,
      companyMsg: {},
      show3: false,
      showInRemark:"",
      dataId: '',
      isSite:false,
      form2: {
        desc: '',
        name: "",
      },
      showOrderPop: false,
      isSendApp:false,
      drawer: true,
      formData: {
        settleFeeType:null,
        punishType:null,
        beginDate:null,
        endDate:null,
      },
    }
  },
  mounted() {
  },
  methods: {
    doCommit(){
      if (!this.formData.punishType){
        this.$message({ message: "请选择奖惩类型", type: 'warning' });
        return false;
      }
      if (!this.formData.settleFeeType){
        this.$message({ message: "请选择结算费用类型", type: 'warning' });
        return false;
      }
      if (!this.formData.beginDate){
        this.$message({ message: "请选择工单开始时间", type: 'warning' });
        return false;
      }
      if (!this.formData.endDate){
        this.$message({ message: "请选择工单结束时间", type: 'warning' });
        return false;
      }
      this.$mask.open()
      this.$http({
        url: api.wkPunishFee.autoAddPunishUrl,
        method: 'post',
        data: this.formData
      }).then(res => {
        this.$mask.close()
        this.$message({
          type: res.data.type,
          message: res.data.content
        });
        if (res.data.code == 0){
          this.drawer = false;
          this.$emit('closeD', 1)
        }
      }).catch(error => {
        this.$mask.close()
      })
    },
    cancelForm() {
      this.drawer = false;
      clearTimeout(this.timer);
      this.$emit('closeD', 0)
    },
    handleClose() {
      this.drawer = false;
      this.$emit('closeD', 0)
    },

  }
}
</script>
<style lang="scss" scoped>
.details2{

  ::v-deep .el-drawer .el-drawer__body {
    padding: 0 16px;
    background-color: #fff;
    position: relative;
  }

  ::v-deep .el-drawer .el-drawer__header {
    background-color: #fff;
  }

  ::v-deep .el-drawer__container {
    position: relative;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    background: aliceblue;
    background-color: rgb(38 38 38 / 70%);
  }

  #containt .table-detail {
    border-collapse: collapse;
    font-size: 12px;
    border: 1px solid #ededed;
  }

  .btn {
    text-align: center;
  }
  //   3个标签
  .information {
    padding: 0px 10px;
    background-color: #E1F2FF;
    color: #268AEA;
    border-radius: 3px;
    margin: 0 5px;
    font-size: 15px;
  }
  //   每个分支
  .d-item {
    border: 1px solid #ededed;
    padding-bottom: 5px;

    .title b {
      display: inline-block;
      line-height: 20px;
      font-size: 13px;
      font-weight: 600;
      margin-right: 84px;
      vertical-align: middle;
      color: rgb(42, 100, 148);
      position: relative;
      z-index: 2;
      background: rgba(42, 100, 148, 0.16);
      margin-left: 0px;
      margin-bottom: 8px;
      padding-left: 12px;
      padding-right: 14px;
      border-radius: 0px 28px 28px 0px;
    }
    .table-detail tr {
      margin-bottom: 10px;
      display: block;
      th {
        font-weight: 400;
        text-align: right;
        width: 7vw !important;
        font-size: 12px;
        position: relative;
        padding: 0 5px 0 4px;
        color: rgba(86, 86, 86, 0.96);
      }
      td {
        font-weight: 400;
        // text-align: right;
        width: 10vw !important;
        font-size: 12px;
        position: relative;
        padding: 0 0px 0 4px;
        color: rgba(0, 0, 0,);
      }
    }}

  ::v-deep .el-image__preview {
    width: 60px !important;
    height: 60px !important;
  }

  .pic_main {
    display: flex;
    margin-left: 20px;
    margin-top: 10px;

    .pic_item {
      display: flex;
      margin-right: 40px;

      span {
        white-space:nowrap;
        line-height: 60px;
        font-size: 12px;
        color: rgba(86, 86, 86, 0.96);
        font-weight: 400;

      }
    }
  }

  // 本单费用位置
  .expense {
    position: absolute;
    right: 20%;
    margin-top: 5px;
    color: #00c4b3;
    font-size: 13px;
  }
  // 滚动条样式

  /* 滚动条 */
  ::-webkit-scrollbar {
    width: 5px;
    height: 12px;
  }

  /* 滚动槽 */
  ::-webkit-scrollbar-track {
    border-radius: 0px;
    // background: rgba(224, 7, 7, 0.05);
  }

  /* 滚动条滑块 */
  ::-webkit-scrollbar-thumb {
    border-radius: 00px;
    background: #cfcece;
  }

  // 步骤条 圆的位置
  ::v-deep .el-timeline-item__node--normal {
    left: 0px !important;
    width: 12px;
    height: 12px;
  }
  ::v-deep  .el-step__title {
    font-size: 13px!important;
    line-height: 38px;
  }
}
</style>
